import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Avatar, Col, Row, Spin } from "antd";
import { useCallback, useState } from "react";
const ListMultilingualLanguages = (param)=>{
    let { languages = [], recordId, onClick, children, wrapperProps = {}, ...rest } = param;
    const [isBusy, setBusy] = useState(false);
    const createdTranslations = languages.filter((param)=>{
        let { id } = param;
        return id !== false;
    });
    const missingTranslations = languages.filter((param)=>{
        let { id } = param;
        return id === false;
    });
    const avatarAttrs = {
        size: 13,
        shape: "square",
        style: {
            display: "block",
            width: "auto",
            borderRadius: 5
        }
    };
    const colAttrs = {
        flex: "none",
        style: {
            textAlign: "center",
            paddingRight: 5,
            fontSize: 11,
            cursor: "pointer"
        }
    };
    const handleClick = useCallback(async (translation)=>{
        if (!isBusy) {
            setBusy(true);
            try {
                onClick(recordId, translation);
            } finally{
                setBusy(false);
            }
        }
    }, [
        isBusy,
        onClick,
        recordId
    ]);
    return /*#__PURE__*/ _jsx(Spin, {
        spinning: isBusy,
        ...wrapperProps,
        children: /*#__PURE__*/ _jsxs(Row, {
            align: "middle",
            ...rest,
            children: [
                createdTranslations.map((translation)=>{
                    const { code, flag, id } = translation;
                    return id === recordId ? null : /*#__PURE__*/ _jsxs(Col, {
                        ...colAttrs,
                        onClick: ()=>handleClick(translation),
                        children: [
                            /*#__PURE__*/ _jsx(Avatar, {
                                src: flag,
                                ...avatarAttrs,
                                children: code.toUpperCase()
                            }),
                            /*#__PURE__*/ _jsx(EditOutlined, {})
                        ]
                    }, code);
                }),
                missingTranslations.length > 0 && missingTranslations.map((translation)=>{
                    const { code, flag } = translation;
                    return /*#__PURE__*/ _jsxs(Col, {
                        ...colAttrs,
                        onClick: ()=>handleClick(translation),
                        children: [
                            /*#__PURE__*/ _jsx(Avatar, {
                                src: flag,
                                ...avatarAttrs,
                                children: code.toUpperCase()
                            }),
                            /*#__PURE__*/ _jsx(PlusOutlined, {})
                        ]
                    }, code);
                }),
                children
            ]
        })
    });
};
export { ListMultilingualLanguages };
